// Matches the role the Super Admin server puts in tokens issued to console users.
export const CONSOLE_USER_ROLE = 'superadmin_user';

export const isConsoleUser = () => {
  try {
    return JSON.parse(localStorage.getItem('userData'))?.role === CONSOLE_USER_ROLE;
  } catch {
    return false;
  }
};
